<template>
    <div id="news-details-page" class="page news-details">
        <div class="news-details__head">
            <div class="container-xl">
                <div class="row">
                    <div class="col-12">
                        <div class="breadcrumb breadcrumb--desctop" v-if="newsCategory.length>0">
                            <router-link :to="{ name:'Home'}">
                                {{ lang('breadcrumb_kezdooldal') }}
                            </router-link>
                            <span class="separate">></span>
                            <router-link :to="{ name:'NewsAll_' + currentLangName()}">
                                {{ lang('breadcrumb_aktualis') }}
                            </router-link>
                            <span class="separate">></span>
                            <router-link :to="{ name:'News_' + currentLangName(), params: {news_category_slug: currentItemCategorySlug}}">
                                {{ currentItemCategoryName }}
                            </router-link>
                            <span class="separate">></span>
                            <span class="current-news">{{ currentItem.name }}</span>
                        </div>
                        <div class="breadcrumb--mobile breadcrumb">
                            <router-link :to="{ name:'NewsAll_' + currentLangName()}">
                                 {{ lang('vissza_az_aktualisokhoz') }}
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="row">             
                    <div class="col-12 news-details__main-data">                      
                        <h1 data-share-title>{{ currentItem.name }}</h1>                       
                    </div>
                </div>
            </div>
        </div>
        <div class="container-xl">
            <div class="row news-details__content">               
                <div class="col-12 col-md-8 col-lg-9 news-details__desc-wrap">    
                    <div class="news-details__desc-wrap--inner">
                        <div class="news-details__short-desc" v-if="currentItem.short_description">
                            {{ currentItem.short_description }}
                        </div>
                        <div class="news-details__desc details-page-desc" v-if="currentItem.description" v-html="currentItem.description">
                            {{ currentItem.description }}
                        </div>  
                        <div class="social-share-row">
                            <SocialShare />
                        </div>                                      
                    </div>                                  
                </div>                                
                <div class="col-12 col-md-4 col-lg-3 news-details__related-news-wrap">                    
                    <div class="news-details__related-news" v-if="relatedNews.length > 0">                        
                        <h4>{{ lang('kapcsolodo_tartalmak') }}</h4>
                        <NewsItem   v-for="news in relatedNews" :key="news.id"
                            :name="news.name"
                            :id="news.id"                                  
                            :news_slug="news.slug"
                            :youtube_id="news.youtube_id"
                            :short_description="news.short_description"
                        />                        
                    </div>  
                    <div class="banner-wrap" v-if="relatedBanners.length > 0">
                        <Banner v-for="banner in relatedBanners" :key="banner.id" 
                                :name="banner.name"
                                :target="banner.link"
                                :src="banner.image.path"
                                :file_name="banner.image.file_name" />
                    </div>                                    
                </div>                    
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import NewsItem from '@/components/pagesComponents/news/NewsItem.vue'
import SocialShare from '@/components/layoutComponents/SocialShare.vue'
import Banner from '@/components/layoutComponents/Banner.vue'

export default {
    data(){
        return{
            currentItem: [],            
            src_url: process.env.VUE_APP_BIFROST_API_URL_NO_PROJECTNAME,
            relatedNews: [],
            relatedBanners: [],
            metaImg: {
                src: null                
            },                       
        }
    },
    components:{
        NewsItem,
        SocialShare,
        Banner        
    },
    computed:{        
        currentItemtSlug(){
            return this.$route.params.news_slug;
        },
        currentItemCategorySlug(){
            return this.$route.params.news_category_slug;
        },
        newsCategory(){
            return this.$store.getters.getNewsCategory
        },
        currentItemCategoryName(){            

            return this.newsCategory.find( item => item.slug == this.$route.params.news_category_slug).name

        }
    },
    watch:{
        currentItemtSlug: function(){
            this.relatedRNews = [],            
            this.getCurrentItemData();
        }          
    },
    methods:{
        getCurrentItemData(){    
            let _this = this       
            let selectedLangId =this.$store.getters.getSelectedLang.id

            axios.get(process.env.VUE_APP_BIFROST_API_URL + '/information/'+ this.currentItemtSlug + '?relations=1&relations_params[information][where][0][0]=where&relations_params[information][where][0][1]=status&relations_params[information][where][0][2]=1&relations_params[information][order_by][0][0]=sort_order&relations_params[information][order_by][0][1]=asc&relations_params[banner][relations]=1&relations_params[banner][where][0][0]=where&relations_params[banner][where][0][1]=status&relations_params[banner][where][0][2]=1&relations_params[banner][relations_params][banner_image][where][0][0]=where&relations_params[banner][relations_params][banner_image][where][0][1]=language_id&relations_params[banner][relations_params][banner_image][where][0][2]=' + selectedLangId + '&relations_params[banner][relations_params][banner_image][order_by][0][0]=sort_order&relations_params[banner][relations_params][banner_image][order_by][0][1]=asc'  ,{
                params:{
                    "language_id": this.$store.getters.getSelectedLang.id                         
                }
            }).then(response => {
                
                if (response.data.status == true){
                    // console.log('aktualis', response.data)
                    if ( parseInt(response.data.information[0].status) === 1 ){
                        this.currentItem = response.data.information[0]  

                        //related info
                        if (response.data.information[0].information){
                            this.getRelatedData()
                        } else {
                            this.relatedNews = []
                        }

                         // //banner
                        if ( response.data.information[0].banner){
                            let banners = response.data.information[0].banner;                            
                            
                            banners.forEach(element => {
                                //need this because of the language_id parameter - if the lang id different, we don't get the banner_image
                                if (element.banner_image){
                                    element.banner_image.forEach(item => {
                                        _this.relatedBanners.push(item)
                                    })                                     
                                }
                            });                            
                        } else {
                            _this.relatedBanners = []
                        }
                      

                        //meta tags
                        if ( !response.data.information[0].meta_image ) {                              
                            _this.metaImg = null
                        } else {                            
                            let meta_image_src = process.env.VUE_APP_BIFROST_API_URL_NO_PROJECTNAME + '/' + response.data.information[0].meta_image.path + response.data.information[0].meta_image.file_name
                            _this.metaImg = meta_image_src
                        }
                        this.setCurrentMetaTags()
                    } else {
                        this.$router.push({name: '404-page'})
                    }                                       
                } else {
                    this.$router.push({name: '404-page'})
                }
                                                                                    
            })
            .catch((err) => {
                console.log(err)
            });             
            
        },
        getRelatedData(){            
            this.relatedNews = this.currentItem.information            
        },
        setCurrentMetaTags(){
            let _this = this            

            this.setMetaTags({
                title: _this.currentItem.meta_title, 
                desc: _this.currentItem.meta_description, 
                keywords: _this.currentItem.meta_keywords, 
                ogType: 'article', 
                ogTitle: _this.currentItem.meta_title,
                ogImage: _this.metaImg, 
                ogImageWidth: null, 
                ogImageHeight: null, 
                ogDesc: _this.currentItem.meta_description
            })
        }            
    },
    created(){                        
        this.getCurrentItemData();
    }   
}
</script>